<template>
  <div class="login-container">
    <div
      class="steps"
      :style="{
        borderBottom:
          isButtonList && showStepSelectGame ? 'none' : '2px solid #808080',
      }"
    >
      <!-- <div v-if="isButtonList && showStepSelectGame" class="chooseyw">
        请选择(Please Select){{ tokens }}
      </div> -->
      <div v-if="isButtonList && showStepUserLogin" class="chooseyw">登录</div>
      <el-steps
        :active="curActive"
        align-center
        v-if="!isButtonList && gameListIsNotEmpty"
      >
        <el-step :title="$t('jtLoginForm.STEP_SELECT_GAME')"></el-step>
        <el-step :title="$t('jtLoginForm.STEP_USER_LOGIN')"></el-step>
      </el-steps>
    </div>
    <div class="step-select-game step" v-if="showStepSelectGame">
      <div v-if="weihu" class="weihu">
        {{ weihu }}
      </div>
      <div v-else-if="gameListIsNotEmpty">
        <div v-if="isButtonList" class="buttonOut">
          <div class="buttonlist">
            <div
              v-for="(item, index) in gameList"
              :key="item.id"
              class="buttonlistli"
              @click="handelselect(index)"
            >
              <p
                :style="{
                  backgroundColor: isButtonNotBg
                    ? 'none'
                    : item['生效'] == 2
                    ? '#888'
                    : colors[index],
                }"
              >
                <!-- <i :class="icons[index]"></i> -->
                <img
                  :src="item['图标']"
                  :style="{ width: isButtonNotBg ? '100%' : '70%' }"
                />
              </p>
              <span>{{ item.label1 ? item.label1 : item.label }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <el-radio-group v-model="curGameIdx" @change="radioChange">
            <el-radio
              v-for="(item, index) in gameList"
              :key="item.id"
              :label="index"
              :style="{ color: item.opening ? '#606266' : '#C0C4CC' }"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
        <div class="btn-container" v-if="!isButtonList">
          <el-button type="primary" @click="nextStep">
            <span class="yahei">{{ buttontext }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <div class="step-user-login step" v-if="showStepUserLogin">
      <div class="form-container">
        <div class="gamename">{{ currentGame.label }}</div>
        <div>
          <div class="row" v-if="currentGame.expire !== '2099-12-31 23:59:59'">
            <div class="col-label">
              {{ $t('jtLoginForm.LABEL_EXPIRE_DATE') }}
            </div>
            <div class="col-content">{{ currentGame.expire }}</div>
          </div>
          <div class="row">
            <div class="col-label">微信昵称</div>
            <div class="col-content">{{ nickname }}</div>
          </div>
          <div class="row">
            <div class="col-label">
              {{ zhuti ? zhuti : $t('jtRegisterForm.LABEL_NAME') }}
            </div>
            <div v-if="username === null">
              <el-tooltip :content="zhutitips" placement="top-start">
                <el-input
                  :placeholder="zhutiplaceholder"
                  v-model="val"
                ></el-input>
                <!-- <el-select v-model="val" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select> -->
              </el-tooltip>
            </div>
            <div class="col-content" v-else>
              {{ username }}
            </div>
          </div>
        </div>
      </div>
      <div class="btn-container">
        <el-button type="primary" @click="prevStep">
          <span class="yahei">{{ $t('jtLoginForm.BTN_PREV_STEP') }}</span>
        </el-button>
        <el-button
          type="primary"
          :disabled="loginBtnDisabled"
          @click="userLogin"
        >
          <span class="yahei">{{ $t('jtLoginForm.BTN_LOGIN') }}</span>
        </el-button>
      </div>
      <div class="footer-container">
        <div>
          <ol v-if="hasGameDescs">
            <li class="attention">{{ $t('jtLoginForm.CHECK_CAREFULLY') }}</li>
            <li v-for="(item, index) in currentGame.descriptions" :key="index">
              <a
                href="#"
                v-if="isModal(item)"
                @click.prevent="showGameDescContent(item)"
                >{{ index + 1 }}. {{ item.title }}</a
              >
              <a
                :href="item.contentOrUrl"
                v-if="isNewPage(item)"
                target="_blank"
                rel="noopener noreferrer"
                >{{ index + 1 }}. {{ item.title }}</a
              >
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        :title="dlgTitle"
        :visible.sync="dlgVisible"
        width="70%"
        :close-on-click-modal="false"
      >
        <div v-html="dlgContent"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { sha256 } from 'js-sha256'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import config from '@/config'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'

const STEP_SELECT_GAME = 0
const STEP_USER_LOGIN = 1

export default {
  name: 'jtLoginForm',
  props: {
    gameList: Array, // 外部传入的比赛列表
    zhuti: String,
    nickname: String,
    username: String,
    checking: Boolean,
    loginloading: Boolean,
    isButtonList: Boolean, //是否按钮列表样式
    isButtonNotBg: Boolean, //按钮无背景
    weihu: String, //是否按钮列表样式
    curindex: Number,
  },
  data() {
    return {
      curActive: STEP_SELECT_GAME, // 当前step，第一步为0
      curGameIdx: 0, // 当前选中的比赛索引
      dlgTitle: '', // 对话框标题
      dlgContent: '', // 对话框内容
      dlgVisible: false, // 显示对话框
      curgameId: 0,
      val: '',
      buttontext: '下一步(Next)',
      colors: [
        '#3f51b5',
        '#e91e63',
        '#ff9800',
        '#9c27b0',
        '#2196f3',
        '#00bcd4',
      ],
      options: [
        '北京市',
        '天津市',
        '河北省',
        '山西省',
        '内蒙古自治区',
        '辽宁省',
        '吉林省',
        '黑龙江省',
        '上海市',
        '江苏省',
        '浙江省',
        '安徽省',
        '福建省',
        '江西省',
        '山东省',
        '河南省',
        '湖北省',
        '湖南省',
        '广东省',
        '广西壮族自治区',
        '海南省',
        '重庆市',
        '四川省',
        '贵州省',
        '云南省',
        '西藏自治区',
        '陕西省',
        '甘肃省',
        '青海省',
        '宁夏回族自治区',
        '新疆维吾尔自治区',
        '新疆生产建设兵团',
        '香港特别行政区',
        '澳门特别行政区',
        '台湾省',
        '中国火车头体育协会',
        '中国金融体育协会',
        '中国石油体育协会',
        '中国煤矿体育协会',
        '中国前卫体育协会',
        '中国建筑体育协会',
        '中国林业体育协会',
        '中国通信体育协会',
        '中国石化体育协会',
        '中国航天体育协会',
        '中国航空体育协会',
        '中国科学院体育协会',
        '中国电子体育协会',
        '中国冶金体育协会',
        '中国水利体育协会',
        '电力体育协会',
        '中国民航体育协会',
        '海关体协',
      ],
    }
  },
  computed: {
    zhutitips() {
      return '第一次登录请正确填写，绑定该微信号后将不得更改'
      // return '第一次登录请正确选择单位，绑定该微信号后将不得更改'
    },
    zhutiplaceholder() {
      return '请输入'
    },
    showStepSelectGame() {
      return this.curActive === STEP_SELECT_GAME || !this.checking
    },
    showStepUserLogin() {
      return this.curActive === STEP_USER_LOGIN && this.checking
    },
    gameListIsNotEmpty() {
      return !(this.gameList == null || _.isEmpty(this.gameList))
    },
    currentGame() {
      return this.gameList[this.curGameIdx]
    },
    loginBtnDisabled() {
      return _.isEmpty(this.val) && _.isEmpty(this.username)
    },
    hasSignupUrl() {
      return this.currentGame.enableRegister
    },
    hasGameDescs() {
      return this.currentGame.descriptions !== undefined
    },
    signupUrl() {
      return `/signup.html?gameId=${this.currentGame.id}`
    },
  },

  methods: {
    nextStep() {
      let thisgame = this.gameList[this.curGameIdx]
      let url = thisgame['URL重定向']
      let code = thisgame['二维码']
      let opions = thisgame['选择模式']
      let sx = thisgame['生效'] == 2
      let cozeId = thisgame['COZE']
      if (sx) {
        this.$alert('服务未开通，敬请期待！', '提示', {
          confirmButtonText: '确定',
        })
      } else if (url) {
        window.open(url)
      } else if (code) {
        let mes = (
          <div>
            <img src={code} style={{ width: '100%', maxWidth: '400px' }} />
          </div>
        )
        this.$alert(mes, '微信扫描下方二维码', {
          customClass: 'code',
          confirmButtonText: '关闭',
          dangerouslyUseHTMLString: true,
        })
      } else {
        let languageConfig = thisgame['语言']
        storage.setItem(constants.LANGUAGE, languageConfig)
        if (languageConfig) {
          const lang = {
            中文: 'zh',
            英文: 'en',
            中英文: 'enAndzh',
            繁体中文: 'cn'
          }
          const language = languageConfig
          this.$i18n.locale = lang[language]
          this.$i18n.fallbackLocale = lang[language]
          if (languageConfig == '中文') {
            locale.use(zhLocale)
          } else if (languageConfig == '繁体中文') {
            locale.use(zhTWLocale)
          } else {
            locale.use(enLocale)
            document.body.style.fontFamily = 'Arial'
          }
        } else {
          this.$i18n.locale = process.env.VUE_APP_I18N_LOCALE || 'zh'
          this.$i18n.fallbackLocale = process.env.VUE_APP_I18N_LOCALE || 'zh'
        }

        if (!thisgame.opening) {
          let a = '该报名还未开通'
          let b = '，开通时间为：'
          let con = thisgame.openingData ? a + b + thisgame.openingData : a
          this.$alert(con, '提示', {
            confirmButtonText: '确定',
          })
        } else if (this.curgameId === thisgame.id) {
          this.curActive = STEP_USER_LOGIN
        } else {
          this.$emit('wxbase', thisgame.id)
          this.curgameId = thisgame.id
          this.curActive = STEP_USER_LOGIN
        }
      }
      if (cozeId) {
        this.$root.COZEID = cozeId
        storage.setItem('COZEID', cozeId)
      }
    },
    prevStep() {
      this.curActive = STEP_SELECT_GAME
    },
    showGameDescContent(description) {
      if (this.isModal(description)) {
        this.dlgTitle = description.title
        this.dlgContent = description.contentOrUrl
        this.dlgVisible = true
      }
    },
    userLogin() {
      try {
        const userInfo = { gameId: this.currentGame.id, val: this.val }
        this.$emit('login', userInfo)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    isModal(description) {
      return description.output === 1 // 1: modal
    },
    isNewPage(description) {
      return description.output === 2 // 2: newpage
    },
    radioChange(index) {
      let thisgame = this.gameList[index]
      let url = thisgame['URL重定向']
      let code = thisgame['二维码']
      if (url) {
        this.buttontext = '跳转登录'
      } else if (code) {
        this.buttontext = '打开二维码'
      } else {
        this.buttontext = '下一步(Next)'
      }
    },

    handelselect(index) {
      this.curGameIdx = index
      this.nextStep()
    },
  },
}
</script>

<style lang="stylus" scoped>
.steps {
  padding: 16px;
  border: 2px solid gray;
}

.chooseyw {
  width: 100%;
  text-align: center;
  font-size: 22px;
  font-weight: blod;
}

.step {
  min-height: 320px;
  border: 2px solid gray;
  border-top: none;
  padding: 8px;
}

.step-select-game >>> .el-radio-group {
  min-height: 280px;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .el-radio {
    height: 32px;
    line-height: 32px;
    padding: 2px;
    white-space: normal;

    .el-radio__label {
      font-size: 16px;
    }
  }
}

.step-select-game >>> .btn-container {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .el-button {
    font-size: 16px;
    width: 50%;
  }
}

.weihu {
  font-size: 40px;
  text-align: center;
  margin-top: 80px;
}

.step-user-login {
  .form-container {
    min-height: 200px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .gamename {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .row {
      line-height: 24px;
      margin-bottom: 10px;

      .col-label {
        margin-bottom: 5px;
        color: #666;
      }

      .col-content {
        font-weight: bold;
        color: #000;
        background-color: #f1f1f1;
        padding: 0 10px;
      }

      .col-content >>>.el-input__inner {
        color: #000;
      }
    }
  }

  .btn-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 10px;

    .el-button {
      font-size: 16px;
      width: 40%;
    }
  }

  .footer-container {
    padding-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    li {
      padding-bottom: 5px;
    }

    .attention {
      font-weight: bold;
    }
  }
}

.buttonOut {
  display: flex;
  align-items: center;
  min-height: 300px;
  justify-content: center;
}

.buttonlist {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0px 0;
  justify-content: space-around;

  .buttonlistli {
    text-align: center;
    padding: 8px;
    cursor: pointer;
    width: 150px;
    transition: 0.25s ease-out;
    border-radius: 5px;

    &:hover {
      -webkit-transform: translateY(-10px);
      transform: translateY(-10px);
    }

    p {
      color: #fff;
      width: 80px;
      height: 80px;
      line-height: 73px;
      text-align: center;
      margin: 10px auto;
      font-size: 32px;
      border-radius: 50%;
    }

    span {
      display: inline-block;
      color: #000;
      text-align: center;
      line-height: 22px;
    }

    img {
      width: 70%;
    }
  }
}

@media screen and (max-width: 768px) {
  .step-select-game >>> .el-radio-group {
    .el-radio {
      height: auto;
    }
  }

  .step-user-login {
    .form-container {
      .row {
        .col-label {
          color: #333;
        }
      }
    }
  }

  .buttonlist {
    .buttonlistli {
      width: 130px;

      p {
        width: 75px;
        height: 75px;
        line-height: 75px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}
</style>
